import React from 'react';
import { Modal, IconButton, ListItemSecondaryAction, ListItem, ListItemText, ListItemIcon, makeStyles } from '@material-ui/core';
import { ChevronLeftOutlined, Close } from '@next-common/material-ui-icons';
import { colorPalette } from '../../colorPalette';
import { PaperModal } from './StyledModal.style';
export const useStyles = makeStyles({
    backIcon: {
        color: colorPalette.gray900,
        minWidth: 'auto',
        height: 24,
    },
});
const StyledModal = ({ id, open, onClose, children, modalStyle, title, backNavigation, backOnClick, dataQa, divider, }) => {
    const classes = useStyles();
    return (React.createElement(Modal, { id: id, open: open, onClose: onClose, onBackdropClick: () => onClose('closeButtonClick'), style: { zIndex: 9999 } },
        React.createElement(PaperModal, { id: "PaperModal", style: modalStyle },
            React.createElement(ListItem, { key: `Header${title}`, ContainerComponent: "header", divider: divider, style: { padding: '16px 48px 16px 16px' } },
                backNavigation ? (React.createElement(ListItemIcon, { className: classes.backIcon },
                    React.createElement(IconButton, { "aria-label": "Retour", size: "small", onClick: backOnClick },
                        React.createElement(ChevronLeftOutlined, { fontSize: "small" })))) : null,
                React.createElement(ListItemText, { "data-qa": dataQa, primary: title, primaryTypographyProps: { align: 'center' } }),
                React.createElement(ListItemSecondaryAction, null,
                    React.createElement(IconButton, { "aria-label": "Fermer", size: "small", onClick: () => onClose('closeButtonClick') },
                        React.createElement(Close, { fontSize: "small" })))),
            children)));
};
export default StyledModal;
